module.exports = "<button class=\"btn {{$ctrl.buttonClass}} {{$ctrl.buttonSize}}\" ng-click=\"$ctrl.openModal()\">{{$ctrl.label}}</button>"


//////////////////
// WEBPACK FOOTER
// ./client/components/modal-button-widget/modal-button-widget.component.html
// module id = 651
// module chunks = 0